export const AUTH_PASSWORD_RECOVERY_URL = '/password-recovery';
export const AUTH_URL = '/auth';

export const BASE_URL = "/login"

export const getUrl = (url: string) => {
    return BASE_URL + url;
}